export const fontSizes = [
    { value: null, label: 'inherit' },
    { value: 4, label: '4 pt' },
    { value: 6, label: '6 pt' },
    { value: 8, label: '8 pt' },
    { value: 10, label: '10 pt' },
    { value: 12, label: '12 pt' },
    { value: 14, label: '14 pt' },
    { value: 16, label: '16 pt' },
    { value: 18, label: '18 pt' },
    { value: 20, label: '20 pt' },
    { value: 22, label: '22 pt' },
    { value: 24, label: '24 pt' },
    { value: 26, label: '26 pt' },
    { value: 28, label: '28 pt' },
    { value: 32, label: '32 pt' },
    { value: 36, label: '36 pt' },
    { value: 40, label: '40 pt' },
    { value: 48, label: '48 pt' },
    { value: 56, label: '56 pt' },
    { value: 64, label: '64 pt' },
    { value: 72, label: '72 pt' },
    { value: 80, label: '80 pt' },
    { value: 90, label: '90 pt' },
    { value: 100, label: '100 pt' },
  ];

export const fontFaces = [
    { value: null, label: 'inherit' },
    { value: 'Arial', label: 'Arial' },
    { value: 'Arial Black', label: 'Arial Black' },
    { value: 'Courier New', label: 'Courier New' },
    { value: 'Comic Sans MS', label: 'Comic Sans MS' },
    { value: 'Times', label: 'Times' },
    { value: 'Times New Roman', label: 'Times New Roman' },
    { value: 'Calibri', label: 'Calibri' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Impact', label: 'Impact' },
    { value: 'Verdana', label: 'Verdana' },
    { value: 'Trebuchet MS', label: 'Trebuchet MS' },
    { value: 'Helvetica', label: 'Helvetica' },
    // { value: 'Roboto', label: 'Roboto' },
  ];
